import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo_dark from '../../assets/images/logo-light.png';
import logo_light from '../../assets/images/logo-light.png';

export default function VegaNavbar({ density = 'comfortable' }) {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    function onScroll() {
      setScrolled(window.scrollY >= 50 || document.body.scrollTop >= 50);
    }
    window.addEventListener('scroll', onScroll);
    window.scrollTo(0, 0);
    return () => window.removeEventListener('scroll', onScroll);
  }, [location.pathname]);

  const navHeight = density === 'compact' ? 56 : 72;

  return (
    <header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 30,
        width: '100%',
        borderBottom: '1px solid var(--line-soft)',
        background: scrolled
          ? 'color-mix(in srgb, var(--bg) 96%, transparent)'
          : 'color-mix(in srgb, var(--bg) 88%, transparent)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        transition: 'background 0.2s ease',
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 1.5rem',
          height: `${navHeight}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
          <img src={logo_dark} alt="Vega" height="28" className="inline-block dark:hidden" style={{ height: '28px', width: 'auto' }} />
          <img src={logo_light} alt="Vega" height="28" className="hidden dark:inline-block" style={{ height: '28px', width: 'auto' }} />
        </Link>

        {/* Nav links — hidden on mobile */}
        <nav
          className="hidden md:flex"
          style={{ alignItems: 'center', gap: '2rem', fontSize: '0.875rem' }}
        >
          {[
            { href: '#product',  label: 'Product' },
            { href: '#atlas',    label: 'Atlas' },
            { href: '#deploy',   label: 'Deploy' },
            { href: '#sectors',  label: 'Sectors' },
            { href: '#faq',      label: 'FAQ' },
          ].map(({ href, label }) => (
            <a
              key={href}
              href={href}
              className="vd-ink-soft"
              style={{ textDecoration: 'none', transition: 'color 0.15s', fontWeight: 500 }}
              onMouseOver={e => { e.currentTarget.style.color = 'var(--ink)'; }}
              onMouseOut={e => { e.currentTarget.style.color = ''; }}
            >
              {label}
            </a>
          ))}
        </nav>

        {/* CTA buttons */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <a
            href="https://www.fundable.com/archetypical-software-vega"
            target="_blank"
            rel="noreferrer"
            className="vd-btn-ghost hidden sm:inline-flex"
          >
            Invest
          </a>
          <a
            href="https://calendly.com/raj-archetypical"
            target="_blank"
            rel="noreferrer"
            className="vd-btn-primary"
          >
            Book a demo
          </a>
        </div>
      </div>
    </header>
  );
}
